import React, { Component, Fragment, useState, useEffect, useRef } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { Link, useNavigate } from "react-router-dom";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import bankup from "../../assets/images/bank-upload.svg";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useCustomizeContext } from "../../context/index";
import { Notify } from "notiflix";
import { useTranslation, I18nextProvider } from "react-i18next";
import { getUserDetails } from "../../Features/SiteSettings/siteSettingSlice";
import { currencyreq } from "../../Features/WalletDetails/walletBalanceSlice";
import { NumericFormat } from 'react-number-format';
import avatar from '../../assets/images/Avatar.png';
import circle from '../../assets/images/close-circle.png';
import copy from "copy-to-clipboard";




import QRCode from "react-qr-code";
import {
  Modal,
  ModalHeader,

  ModalBody
} from "reactstrap";



import {
  getcreatepayment,
  getpaymenthistory
} from "../../Features/Transaction/transactionSlice";
import { useSelector } from "react-redux";
import axios from 'axios';




import {
  getUserbank,
  addDepositreq,
  getAdminbankdetails,
} from "../../Features/Bankdetails/bankDetailsSlice";

const Deposit = (props) => {
  const { currencyRes } = useSelector(state => state.wallet);

  const [depositModal, setDepositModal] = useState(false);

  const [qrdata, setQrdata] = useState({});




  const kycdata = useSelector((state) => state?.siteSettings?.userDetails?.data?.details)
  // console.log('kycdata: ', kycdata);
  const useremail = useSelector((state) => state?.siteSettings?.userDetails?.data?.email)



  const amountRef = useRef();

  const expirydaysRef = useRef();




  const { t, i18n } = useTranslation();
  const {
    loader: { loading, setLoading },
    sideMenu: {
      classIsActive, setClassIsActive
    },

  } = useCustomizeContext();
  const [img, setImg] = useState();

  let navigate = useNavigate();

  const [kycstatus, setKycstatus] = useState();


  const [payment, setPayment] = useState("pix");
  const [uploadimg, setUploadimg] = useState();
  const format = ["image/jpg", "image/png", "image/jpeg"];
  const [bankdata, setBankdata] = useState({});
  const [adminbankdata, setAdminBankdata] = useState({});
  const [currencydata, setCurrencydata] = useState();

  const [hash_data, setHash_data] = useState("");

  const [deposit, setDeposit] = useState();


  const deposit_amount = deposit / 100;


  const [cardnumber, setCardnumber] = useState();
  const [holdername, setHoldername] = useState();
  const [expirymonth, setExpirymonth] = useState();
  const [expirydays, setExpirydays] = useState(1);
  const [expiryyear, setExpiryyear] = useState();
  const [cvv, setCvv] = useState();

  const [name, setName] = useState();

  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();


  const [checkamount, setCheckamount] = useState();
  const [title, setTitle] = useState();

  const [updatestate, setUpdatestate] = useState(false);

  const [calcdep, setCalcdep] = useState();






  let dispatch = useDispatch();

  const [bankname, setBankname] = useState([]);
  const [adminbankname, setAdminbankname] = useState([]);
  const {
    register,
    reset,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {

    userHomepage();
    currencylist();
    getpaymenthistory();
  }, []);


  const toggleBetDetails = () => {
    setDepositModal(!depositModal);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setClassIsActive(false);
    document.body.classList.remove("SideMenuOpen");
  }, []);

  function currencyFormatter(value) {
    if (!Number(value)) return "";

    const amount = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(value / 100);


    return amount;
  }


  const onSubmit = async (data, e) => {

    e.preventDefault();

    if (!deposit) {
      amountRef.current.focus()
    }



    else if (deposit < currencydata?.min_deposit) {

      Notify.failure(`${t("Deposit amount must be greater than minimum deposit amount")}`, {
        showOnlyTheLastOne: true,
        clickToClose: true,
        timeout: 1500,
      });
    }

    else {

      setLoading(true);




      var options =
      {
        method: 'POST',


        url: 'https://api.sandbox.hopysplit.com.br/v1/transactions',
        headers: { accept: 'application/json', 'content-type': 'application/json', authorization: 'Basic c2tfbGl2ZV9mWGVaaGJBSVVmRWIyZ3NXM0JET0E5Z3c0R1pvWFI6eA==' },



        data: {
          token: "",
          amount: Number(deposit) * 100,
          paymentMethod: payment,


          installments: 0,


          customer: {

            id: 0,
            name: kycdata?.username,
            email: useremail,

          },

          items: [
            {
              title: "Rico Jogos(deposit)",
              unitPrice: 100,
              quantity: 1,
              tangible: false,
              externalRef: 'Rico jogos'
            }
          ],
          boleto: { expiresInDays: 0 },
          pix: { expiresInDays: Number(expirydays) },
          postbackUrl: 'https://apiricojogos.osiztech.com/user/update_transaction',
          metadata: 'Rico jogos',
          traceable: true,
          sendEmail: true,
          capture: true,
          ip: kycdata?.ip_address,
        }

      }

      await axios
        .request(options)
        .then(async function (response) {



          if (response?.data?.status == "waiting_payment") {
            setDeposit("")

            setQrdata({
              ...qrdata,
              secure_url: response?.data?.secureUrl,
              id: response?.data?.id,
              qr_code: response?.data?.pix?.qrcode,
              email: response?.data?.customer?.email
            });


            let data = {
              "amount": Number(response?.data?.amount) / 100,
              "paymentMethod": response?.data?.paymentMethod,

              "name": response?.data?.customer?.name,
              "email": response?.data?.customer?.email,
              "phone": response?.data?.customer?.phone,
              "boleto": response?.data?.boleto,
              "pix": response?.data?.pix?.expirationDate,
              "secure_url": response?.data?.secureUrl,
              "id": response?.data?.id,
              "qr_code": response?.data?.pix?.qrcode
            }

            await createpayment(data)





          }
          else {

            setLoading(false)
          }
        })
        .catch(function (error) {
          console.error(error, "error");



          Notify.failure(`${t("We were unable to process your request at this time, please try again later.")}`, {
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
          });



          // Notify.failure(error?.response?.data?.message, {
          //   showOnlyTheLastOne: true,
          //   clickToClose: true,
          //   timeout: 1500,
          // });
          setLoading(false);
          setDeposit("")
        });
    }



  };



  const currencylist = async () => {
    let res = await dispatch(currencyreq({ "currency_symbol": "R$" }));
    if (res?.status) {

      setCurrencydata(res?.data)

    }
  };

  const createpayment = async (data) => {
    let res = await dispatch(getcreatepayment(data));

    if (res?.status) {
      setLoading(false);
      toggleBetDetails();
    }
    else {
      setLoading(false);
    }

  };

  const copyToClipboard = () => {
    copy(qrdata?.qr_code);



    Notify.success(`${t("Link copied to clipboard")}`, {
      showOnlyTheLastOne: true,
      clickToClose: true,
      timeout: 1500,
    });

  }














  const userHomepage = async () => {
    setLoading(true);
    let res = await dispatch(getUserDetails());

    setTimeout(() => {
      if (res?.status) {
        setKycstatus(res?.data?.details?.kycfinal_status)
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    }, 1000);
  }



  return (
    <Fragment>
      <Header />
      <div class="mainbody-content">
        <Sidebar />
        <div class="center-maincnt">
          <div class="inr-container">
            <div class="center-inrcnt">
              <div class="bankdetails-main">

                <div className="depositpage-maincnt">
                  <div class="depsitpage-maincnt" style={{ margin: "auto" }}>
                    <h5 class="page-head">{t("Deposit")}</h5>
                    <div class="deposit-form">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{t("Payment Method")}</label>
                              <input
                                type="text"
                                class="form-control"
                                value="PIX"
                              />
                            </div>
                          </div>



                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>{t("Enter Your Amount")}</label>

                              <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                  <span class="input-group-text text-white" id="basic-addon1">R$</span>
                                </div>
                                <NumericFormat class="form-control" getInputRef={amountRef} placeholder={`${t('Enter Your Amount')}`} allowNegative={false} value={deposit}
                                  // prefix="R$"
                                  onValueChange={(values, sourceInfo) => {

                                    setDeposit(values?.floatValue)
                                  }}
                                />
                              </div>







                            </div>

                          </div>
                          <div className="valuebtn-grid">
                            <p className="valuebtn"
                              onClick={() => setDeposit(30)}
                            >
                              R$ 30
                            </p>

                            <p className="valuebtn"

                              onClick={() => setDeposit(50)}
                            >
                              R$ 50
                            </p>

                            <p className="valuebtn"

                              onClick={() => setDeposit(200)}
                            >
                              R$ 200
                            </p>

                          </div>
                        </div>

                        <div class="tot-amount">

                          <p> {t("Min Deposit")}:{currencydata?.min_deposit} BRL</p>
                        </div>

                        <h6 className="tot-amount" style={{ color: "#93a1c0" }}>{t("Note")} : {t("The PIX code generated will be valid for a period of 30 minutes")}.</h6>





                        <div>
                          <button class="btn btn-primary submit-btn"
                          >
                            {t("Generate PIX")}
                          </button>
                        </div>




                      </form>
                      <br></br>






                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div >

      <Modal
        isOpen={depositModal}
        toggle={toggleBetDetails}
        className="minesmodal-popup"
        autoFocus={false}
        centered
      >

        <ModalBody className="p-0">

          <div class="minesmodal-content text-white">
            <div style={{
              "display": "flex",
              "justify-content": "space-between"
            }}>
              <h2>{t("Transaction")}#{qrdata?.id}</h2>
              <div >
                <Link to="#" onClick={toggleBetDetails}>
                  <img src={circle} alt="" />
                </Link>
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-lg-12">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <div class="mines-detbox text-white">
                      <QRCode
                        size={180}
                        // style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        // value="hello world"
                        value={qrdata?.qr_code}
                      // viewBox={`0 0 256 256`}
                      />


                      <h6 className="mt-3">{t("View transaction online")}</h6>
                      <h6>{t("The customer has already received the transaction at")}</h6>
                      <h6 className="breakWords">{qrdata?.email}</h6>
                      <input className="form-control" defaultValue={qrdata?.qr_code} />

                    </div>

                  </div>

                </div>
                <div class="row mt-3">

                  <div class="col-sm-12 col-md-12 my-3 my-md-0 mx-auto">
                    <div class="mines-detmain">
                      <p style={{ "cursor": "pointer" }} onClick={copyToClipboard}>{t("Copy Link")}</p>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment >
  );
};

export default Deposit;
